<template>
	<div class="kfbox">
		<!-- @clickOverlay="Popclose" @clickCloseIcon="Popclose" -->
		<van-popup v-model="isshow" :round="true" closeable @close="Popclose">
			<div class="kf_List">
				<div class="kf_item flexC">
					<div class="kf_img">
						<img :src="Config.kf_logo!=null?Config.kf_logo:'@/assets/wap/images/icon/kfimg.png'" />
					</div>
					<div class="kf_cont">
						<p class="kf_p1">{{$t('message.kefu')}}：<span class="big_p">{{Config.kf_name}}</span></p>
						<p class="kf_p2"><span class="big_p">ID：</span><span
								class="big_p big_red">{{Config.kf_id}}</span>
						</p>
						<p class="kf_p3">{{$t('message.mykf1desc')}}</p>
					</div>
				</div>
				<div class="kf_item flexC">
					<div class="kf_img ">
						<img :src="Config.kf_rjlogo!=null?Config.kf_rjlogo:'@/assets/wap/images/icon/letstalk.png'" />
					</div>
					<div class="kf_cont">
						<p class="kf_p1">{{Config.kf_title}}</p>
						<p class="kf_p2">{{$t('message.mykf2desc')}}：{{Config.kf_download}}</p>
						<p class="kf_p3">{{Config.kf_desc}}</p>
					</div>
				</div>
				<router-link :to="{name: 'kefu'}" class="kf_item flexC">
					<div class="kf_img ">
						<img src="@/assets/wap/images/icon/kfimg.png" />
					</div>
					<div class="kf_cont">
						<p class="kf_p1">{{$t('message.mykf3desc1')}}</p>
						<p class="kf_p2">{{$t('message.mykf3desc2')}}</p>
						<p class="kf_p3">{{$t('message.mykf3desc3')}}</p>
					</div>
				</router-link>
			</div>
		</van-popup>
	</div>

</template>

<script>
	import {
		queryConfig,
	} from "@/api/urls";
	export default {
		name: 'kefupop',
		props: {
			Popshow: {
				type: Boolean,
				default: false
			},
		},
		data() {
			return {
				isshow: false,
				Config: {},
			};
		},
		computed: {

		},
		mounted() {
			// console.log(this.Popshow); // 输出父组件传递过来的数据
		},
		created() {
			if(this.$store.state.Config!=null){
				this.Config =this.$store.state.Config;
				this.isshow=true;
			}else{
				this.getSystem();
			}		
		},
		methods: {
			//获取系统配置
			getSystem() {
				var params = {
					'lang': this.$store.state.lang,
				}
				queryConfig(params).then(({
					code,
					data,
					msg
				}) => {
					if (code === 200) {
						this.Config = data;
						this.$store.commit('setConfig', data)
						console.log("系统变量", data)
						if (data.site_closevideo == 1) {
							this.$store.commit('setHideVideo', true)
						} else {
							this.$store.commit('setHideVideo', false)
						}
						this.isshow=true;

					}
				})
			},
			// 关闭弹窗
			Popclose() {
				console.log("关闭弹窗");
				this.$emit("close", false)
				// this.Popshow = false;
			}
		}
	};
</script>

<style lang="less" scoped>
	// 客服
	.kf_List {
		width: 340px;
		padding: 20px;
		box-sizing: border-box;

		.kf_item {
			margin: 0.1rem 0;
			justify-content: flex-start;

			.kf_img {
				width: 80px;
				border-radius: 15px;
				overflow: hidden;
				img {
					width: 100%;
					height: 100%;
				}
			}

			.kf_cont {
				flex: 1;
				text-align: left;
				margin-left: 10px;
				color: var(--text-color);

				.kf_p1 {
					font-size: 0.12rem;
				}

				.kf_p2 {
					margin: 0.05rem 0;
					font-size: 0.11rem;
				}

				.kf_p3 {
					font-size: 0.1rem;
				}

				.big_p {
					font-size: 0.12rem;
				}

				.big_red {
					color: #F01212;
				}
			}
		}
	}

	.van-tag {
		font-size: 0.09rem;
	}

	/deep/ .van-popup {
		background-color: var(--bg-color);
	}
</style>


// WEBPACK FOOTER //
// src/components/wap/public/kefupop.vue